
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import Button from '../../components/base/Button';

export default function Blog() {
  const navigate = useNavigate();
  const [selectedCategory, setSelectedCategory] = useState('all');

  const categories = [
    { id: 'all', label: 'All Posts' },
    { id: 'seo', label: 'SEO' },
    { id: 'sem', label: 'SEM & PPC' },
    { id: 'social', label: 'Social Media' },
    { id: 'ai', label: 'AI & Technology' },
    { id: 'industry', label: 'Industry Insights' }
  ];

  const blogPosts = [
    {
      id: 1,
      category: 'seo',
      title: '10 Advanced SEO Strategies for International Markets in 2024',
      excerpt: 'Discover cutting-edge SEO techniques that are driving results for international businesses in competitive markets like mortgage and debt consolidation.',
      author: 'Sarah Mitchell',
      date: 'December 15, 2024',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=Professional%20SEO%20specialist%20analyzing%20international%20search%20rankings%20on%20computer%20screen%20with%20world%20map%20and%20analytics%20charts%2C%20modern%20office%20workspace%20with%20global%20market%20focus&width=600&height=400&seq=blog1&orientation=landscape',
      tags: ['SEO', 'International Marketing', 'Digital Strategy']
    },
    {
      id: 2,
      category: 'ai',
      title: 'How AI is Revolutionizing Lead Qualification and Scoring',
      excerpt: 'Learn how artificial intelligence and machine learning are transforming the way businesses identify and qualify high-value prospects.',
      author: 'Emma Rodriguez',
      date: 'December 12, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=AI%20researcher%20working%20with%20machine%20learning%20algorithms%20for%20lead%20scoring%20on%20multiple%20monitors%20showing%20predictive%20analytics%20and%20artificial%20intelligence%20models%2C%20futuristic%20tech%20office&width=600&height=400&seq=blog2&orientation=landscape',
      tags: ['AI', 'Lead Generation', 'Machine Learning']
    },
    {
      id: 3,
      category: 'sem',
      title: 'Google Ads Optimization for High-Value Industries: A Complete Guide',
      excerpt: 'Master Google Ads strategies specifically designed for mortgage, debt consolidation, and home security industries with higher conversion rates.',
      author: 'Michael Chen',
      date: 'December 10, 2024',
      readTime: '10 min read',
      image: 'https://readdy.ai/api/search-image?query=PPC%20specialist%20optimizing%20Google%20Ads%20campaigns%20on%20computer%20showing%20bid%20management%20and%20keyword%20research%20tools%2C%20professional%20marketing%20office%20with%20performance%20dashboards&width=600&height=400&seq=blog3&orientation=landscape',
      tags: ['Google Ads', 'PPC', 'Conversion Optimization']
    },
    {
      id: 4,
      category: 'industry',
      title: 'The State of Mortgage Lead Generation: 2024 Industry Report',
      excerpt: 'Comprehensive analysis of mortgage lead generation trends, costs, and conversion rates across international markets.',
      author: 'David Thompson',
      date: 'December 8, 2024',
      readTime: '12 min read',
      image: 'https://readdy.ai/api/search-image?query=Financial%20analyst%20presenting%20mortgage%20industry%20report%20with%20charts%20and%20graphs%20to%20executive%20team%20in%20modern%20conference%20room%2C%20professional%20business%20meeting%20atmosphere&width=600&height=400&seq=blog4&orientation=landscape',
      tags: ['Mortgage Industry', 'Market Research', 'Lead Generation']
    },
    {
      id: 5,
      category: 'social',
      title: 'Meta Advertising Strategies for Financial Services Compliance',
      excerpt: 'Navigate Facebook and Instagram advertising regulations while maximizing reach and conversions in the financial services sector.',
      author: 'Sarah Mitchell',
      date: 'December 5, 2024',
      readTime: '7 min read',
      image: 'https://readdy.ai/api/search-image?query=Social%20media%20marketing%20manager%20creating%20compliant%20financial%20ads%20on%20computer%20screen%20showing%20Facebook%20Ads%20Manager%20interface%2C%20professional%20workspace%20with%20compliance%20guidelines&width=600&height=400&seq=blog5&orientation=landscape',
      tags: ['Meta Ads', 'Compliance', 'Financial Marketing']
    },
    {
      id: 6,
      category: 'ai',
      title: 'Predictive Analytics: Forecasting Lead Quality Before They Convert',
      excerpt: 'Implement predictive analytics models to identify high-converting prospects early in the funnel and optimize your marketing spend.',
      author: 'Emma Rodriguez',
      date: 'December 3, 2024',
      readTime: '9 min read',
      image: 'https://readdy.ai/api/search-image?query=Data%20scientist%20analyzing%20predictive%20models%20and%20lead%20scoring%20algorithms%20on%20computer%20screens%20showing%20statistical%20analysis%20and%20forecasting%20charts%2C%20modern%20analytics%20workspace&width=600&height=400&seq=blog6&orientation=landscape',
      tags: ['Predictive Analytics', 'Data Science', 'Lead Scoring']
    },
    {
      id: 7,
      category: 'seo',
      title: 'Local SEO for Home Security Companies: Dominate Your Market',
      excerpt: 'Step-by-step guide to local SEO optimization that helps home security companies capture more qualified leads in their service areas.',
      author: 'Michael Chen',
      date: 'November 28, 2024',
      readTime: '11 min read',
      image: 'https://readdy.ai/api/search-image?query=Local%20SEO%20specialist%20optimizing%20Google%20My%20Business%20listings%20for%20security%20companies%20on%20computer%20with%20local%20search%20results%20and%20map%20rankings%20displayed%2C%20professional%20marketing%20office&width=600&height=400&seq=blog7&orientation=landscape',
      tags: ['Local SEO', 'Home Security', 'Google My Business']
    },
    {
      id: 8,
      category: 'industry',
      title: 'Debt Consolidation Marketing: Regulatory Compliance Best Practices',
      excerpt: 'Navigate complex regulations while building effective marketing campaigns for debt consolidation and financial relief services.',
      author: 'David Thompson',
      date: 'November 25, 2024',
      readTime: '8 min read',
      image: 'https://readdy.ai/api/search-image?query=Compliance%20officer%20reviewing%20financial%20marketing%20regulations%20with%20legal%20documents%20and%20regulatory%20guidelines%20on%20desk%2C%20professional%20law%20office%20with%20financial%20compliance%20focus&width=600&height=400&seq=blog8&orientation=landscape',
      tags: ['Debt Consolidation', 'Compliance', 'Financial Regulations']
    },
    {
      id: 9,
      category: 'sem',
      title: 'Landing Page Optimization: Converting More PPC Traffic in 2024',
      excerpt: 'Advanced landing page strategies that increase conversion rates and reduce cost-per-acquisition for paid search campaigns.',
      author: 'Sarah Mitchell',
      date: 'November 22, 2024',
      readTime: '6 min read',
      image: 'https://readdy.ai/api/search-image?query=UX%20designer%20optimizing%20landing%20page%20conversion%20rates%20on%20computer%20screen%20showing%20A%2FB%20testing%20results%20and%20user%20behavior%20analytics%2C%20modern%20web%20design%20office&width=600&height=400&seq=blog9&orientation=landscape',
      tags: ['Landing Pages', 'CRO', 'PPC Optimization']
    }
  ];

  const filteredPosts = selectedCategory === 'all' 
    ? blogPosts 
    : blogPosts.filter(post => post.category === selectedCategory);

  const featuredPost = blogPosts[0];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      {/* Hero Section */}
      <section className="py-20 bg-gradient-to-br from-blue-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h1 className="text-5xl md:text-6xl font-bold text-gray-900 mb-6">
              Industry Insights & Expertise
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 max-w-3xl mx-auto">
              Stay ahead with the latest strategies, trends, and insights from our lead generation and digital marketing experts.
            </p>
          </div>

          {/* Featured Post */}
          <div className="bg-white rounded-2xl shadow-lg overflow-hidden max-w-4xl mx-auto">
            <div className="grid grid-cols-1 lg:grid-cols-2">
              <img 
                src={featuredPost.image} 
                alt={featuredPost.title}
                className="w-full h-80 lg:h-full object-cover object-top"
              />
              <div className="p-8 lg:p-12 flex flex-col justify-center">
                <div className="flex items-center mb-4">
                  <span className="bg-blue-100 text-blue-600 px-3 py-1 rounded-full text-sm font-medium mr-4">
                    Featured
                  </span>
                  <span className="text-gray-500 text-sm">{featuredPost.readTime}</span>
                </div>
                <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
                  {featuredPost.title}
                </h2>
                <p className="text-gray-600 mb-6 leading-relaxed">
                  {featuredPost.excerpt}
                </p>
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                      <i className="ri-user-line text-blue-600"></i>
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">{featuredPost.author}</div>
                      <div className="text-sm text-gray-500">{featuredPost.date}</div>
                    </div>
                  </div>
                  <Button variant="outline">
                    <i className="ri-arrow-right-line mr-2"></i>
                    Read More
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section className="py-12 bg-gray-50 sticky top-20 z-40">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-wrap justify-center gap-4">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => setSelectedCategory(category.id)}
                className={`px-6 py-3 rounded-full font-medium transition-all cursor-pointer whitespace-nowrap ${
                  selectedCategory === category.id
                    ? 'bg-blue-600 text-white shadow-lg'
                    : 'bg-white text-gray-600 hover:bg-gray-100 border border-gray-200'
                }`}
              >
                {category.label}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Blog Posts Grid */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {filteredPosts.slice(1).map((post) => (
              <article key={post.id} className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-48 object-cover object-top"
                />
                <div className="p-6">
                  <div className="flex items-center justify-between mb-3">
                    <div className="flex flex-wrap gap-2">
                      {post.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="bg-gray-100 text-gray-600 px-2 py-1 rounded text-xs font-medium">
                          {tag}
                        </span>
                      ))}
                    </div>
                    <span className="text-gray-500 text-sm">{post.readTime}</span>
                  </div>
                  
                  <h3 className="text-xl font-bold text-gray-900 mb-3 leading-tight">
                    {post.title}
                  </h3>
                  <p className="text-gray-600 mb-4 leading-relaxed text-sm">
                    {post.excerpt}
                  </p>
                  
                  <div className="flex items-center justify-between pt-4 border-t border-gray-100">
                    <div className="flex items-center">
                      <div className="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center mr-3">
                        <i className="ri-user-line text-blue-600 text-sm"></i>
                      </div>
                      <div>
                        <div className="font-medium text-gray-900 text-sm">{post.author}</div>
                        <div className="text-xs text-gray-500">{post.date}</div>
                      </div>
                    </div>
                    <button className="text-blue-600 hover:text-blue-700 font-medium text-sm cursor-pointer">
                      Read More
                    </button>
                  </div>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      <section className="py-20 bg-blue-50">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <div className="w-16 h-16 flex items-center justify-center bg-blue-100 rounded-full mx-auto mb-6">
            <i className="ri-mail-line text-2xl text-blue-600"></i>
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-6">
            Stay Updated with Industry Insights
          </h2>
          <p className="text-xl text-gray-600 mb-8">
            Get the latest lead generation strategies, industry trends, and expert insights delivered to your inbox weekly.
          </p>
          <div className="max-w-md mx-auto">
            <div className="flex flex-col sm:flex-row gap-4">
              <input
                type="email"
                placeholder="Enter your email address"
                className="flex-1 px-4 py-3 rounded-lg border border-gray-300 focus:border-blue-600 focus:outline-none text-sm"
              />
              <Button>
                <i className="ri-send-plane-line mr-2"></i>
                Subscribe
              </Button>
            </div>
            <p className="text-sm text-gray-500 mt-3">
              No spam, unsubscribe at any time. We respect your privacy.
            </p>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-blue-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Need Expert Guidance for Your Business?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            Let our team of specialists help you implement these strategies and drive real results for your business.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              size="lg"
              onClick={() => navigate('/contact')}
              className="bg-white text-blue-600 hover:bg-gray-100"
            >
              <i className="ri-phone-line mr-2"></i>
              Schedule Consultation
            </Button>
            <Button 
              variant="outline"
              size="lg"
              onClick={() => navigate('/services')}
              className="border-white text-white hover:bg-white hover:text-blue-600"
            >
              <i className="ri-service-line mr-2"></i>
              View Our Services
            </Button>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
